import { Pipe, PipeTransform } from '@angular/core';
import { actionNumberPattern } from '../constants/action-number-pattern';
import { judicialCentres } from '../constants/judicial-centres';

@Pipe({
  name: 'toJudicialCentre',
  pure: true,
})
export class ToJudicialCentrePipe implements PipeTransform {
  transform(actionNumber: string, prop: string = 'title'): string {
    if (!actionNumberPattern.test(actionNumber)) return '';
    const centre = judicialCentres.find((x) => x.re.test(actionNumber));
    return centre?.hasOwnProperty(prop) ? centre[prop] : '';
  }
}
